var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useRecordContext, TextField, Labeled } from 'react-admin';
import get from 'lodash/get';
import { Diff } from './Diff';
import { useReferenceRecordContext } from '../ReferenceRecordContext';
/**
 * Render a diff between a text field of the current record and the same field of the reference record.
 *
 * Uses a word-based diff algorithm. To be used inside a diffElement, for instance in `<RevisionsButton>`.
 *
 * @example
 * import { Stack } from '@mui/material';
 * import { SmartFieldDiff, SimpleFormWithRevision } from '@react-admin/ra-history';
 * import { Edit, TopToolbar } from 'react-admin';
 *
 * const ProductDiff = () => (
 *     <Stack gap={1}>
 *         <SmartFieldDiff source="reference" />
 *         <SmartFieldDiff source="description" />
 *     </Stack>
 * );
 *
 * const ProductEditActions = () => (
 *     <TopToolbar>
 *         <RevisionsButton diff={<ProductDiff />} />
 *     </TopToolbar>
 * );
 *
 * const ProductEdit = () => (
 *    <Edit actions={<ProductEditActions />}>
 *       <SimpleFormWithRevision>
 *          // ...
 *      </SimpleFormWithRevision>
 *   </Edit>
 * );
 */
export var SmartFieldDiff = function (_a) {
    var source = _a.source, label = _a.label, rest = __rest(_a, ["source", "label"]);
    var record = useRecordContext();
    var referenceRecord = useReferenceRecordContext();
    var from = String(get(referenceRecord, source));
    var to = String(get(record, source));
    return from !== to ? (_jsx(Labeled, { source: source, label: label, children: _jsx(Diff, __assign({ from: from, to: to }, rest)) })) : (_jsx(Labeled, { source: source, label: label, children: _jsx(TextField, __assign({ source: source }, rest)) }));
};
